import type { SEOHandle } from "@nasa-gcn/remix-seo";
import type { MetaFunction } from "@remix-run/node";

import LegalPage from "~/components/legal/LegalPage";
import generateSitemapEntriesFor from "~/helpers/sitemapEntriesWithLocal";
import legal from "~/i18n/legal";
import { useT } from "~/i18n/useT";
import { buildMeta, langFromParams } from "~/seo/meta";

/**
 * Required by §5 DDG for any commercial German website. Its absence was the
 * single clearest legal defect on the old site.
 */
export const meta: MetaFunction = ({ params }) => {
  const lang = langFromParams(params);
  const t = legal[lang].imprint;

  return buildMeta({
    lang,
    path: "/imprint",
    title: t.metaTitle,
    description: t.metaDescription,
  });
};

export const handle: SEOHandle = generateSitemapEntriesFor(
  "/imprint",
  undefined,
  "yearly",
  0.3,
);

export default function ImprintPage() {
  const t = useT(legal).imprint;
  return (
    <LegalPage title={t.title} sections={t.sections} showUpdated={false} />
  );
}
